/**
 * BLOCK: How-to Child - Edit Class
 */

import HowToChildStyle from './inline-styles';
import lazyLoader from '@Controls/lazy-loader';
import React, { useEffect, lazy, Suspense } from 'react';

const Settings = lazy(() =>
	import(/* webpackChunkName: "chunks/how-to-child/settings" */ './settings')
);
const Render = lazy(() =>
	import(/* webpackChunkName: "chunks/how-to-child/render" */ './render')
);

const WPSPHowToChild = (props) => {
	useEffect(() => {
		// Replacement for componentDidMount.

		// Assigning block_id in the attribute.
		props.setAttributes({ block_id: props.clientId.substr(0, 8) });

		props.setAttributes({ classMigrate: true });

		// Pushing Style tag for this block css.
		const $style = document.createElement('style');
		$style.setAttribute(
			'id',
			'wpsp-info-box-style-' + props.clientId.substr(0, 8)
		);
		document.head.appendChild($style);
	}, []);

	useEffect(() => {
		// Replacement for componentDidUpdate.
		const element = document.getElementById(
			'wpsp-info-box-style-' + props.clientId.substr(0, 8)
		);

		if (null !== element && undefined !== element) {
			element.innerHTML = HowToChildStyle(props);
		}
	}, [props]);

	return (
		<Suspense fallback={lazyLoader()}>
			<Settings parentProps={props} />
			<Render parentProps={props} />
		</Suspense>
	);
};
export default WPSPHowToChild;
